/**
 * Provider role configurations.
 *
 * These are base provider roles, not therapist/coach-specific.
 */

import { HYBRID_PROVIDER_CALENDAR, PRACTICE_PROVIDER_CALENDAR } from './calendars'
import { RoleConfig } from './types'

/**
 * Individual Provider configuration.
 * All providers have this role, but DA-only providers have *only* this role.
 */
export const INDIVIDUAL_PROVIDER: RoleConfig = {
  bcPlatform: false,
  videoSessionsEnabled: false,
  medicationEnabled: false,
  zendeskWidget: true,
  directAccessClientList: true,
  requestPayment: true,
  eligibilityChecker: true,
  showOverdueMessageFlag: true,
  showInPersonPrompt: true,
  smartSchedulingEnabled: true,
  hidePerformanceMetrics: true,
  showCloseSessionBanner: true,
  inProductCalendar: HYBRID_PROVIDER_CALENDAR,
  showCareInsights: false,
}

/**
 * Practice Provider configuration.
 * Providers associated with a practice.
 */
export const PRACTICE_PROVIDER: RoleConfig = {
  zendeskWidget: false,
  eligibilityChecker: true,
  smartSchedulingEnabled: true,
  paymentHistory: false,
  hidePerformanceMetrics: true,
  inProductCalendar: PRACTICE_PROVIDER_CALENDAR,
}
